import { FC } from 'react';

const DownloadIcon: FC = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66661 13.1667L9.99994 16.5M9.99994 16.5L13.3333 13.1667M9.99994 16.5V9.00001M17.3999 14.075C18.1244 13.5655 18.6677 12.8385 18.951 11.9993C19.2343 11.1601 19.2428 10.2525 18.9753 9.40819C18.7078 8.56387 18.1782 7.82675 17.4633 7.30381C16.7485 6.78087 15.8856 6.49931 14.9999 6.50001H13.9499C13.6993 5.52323 13.2304 4.61605 12.5784 3.84674C11.9264 3.07743 11.1084 2.46606 10.186 2.05863C9.2635 1.65121 8.26065 1.45836 7.25288 1.4946C6.24512 1.53084 5.25871 1.79523 4.36791 2.26786C3.47711 2.74049 2.70513 3.40905 2.1101 4.2232C1.51507 5.03735 1.11249 5.97588 0.932662 6.96813C0.752836 7.96038 0.800453 8.9805 1.07193 9.95169C1.3434 10.9229 1.83166 11.8198 2.49994 12.575"
        stroke="inherit"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownloadIcon;
